import { computed, ref } from "vue";
import { GET_SERVER_REQUEST, SERVER_REQUEST } from "./ServerConnect";
import { loadingStore } from "./LoadingStore";
import { MAX_TIME, mouseHoveredDevice, state } from "./SearchDevice";
import { baseStationMarkers, defaultLocation, defaultZoomLevel, fetchCustomMarker, isPOIModalSimpleOpen, isPOIModalSimpleOpen2, mouseHoveredNB, mouseHoveredNBMarker, mouseHoveredCPE, mouseHoveredCPEMarker, CPEMarkers } from "./MapSetting";
import { isAuthEditModalOpen, isDeviceModalSimpleOpen, isMenuModalOpen, isPathModalOpen, showSmallModal } from "./ModalUtility";
import { isMeasuring, stopMeasuring } from "./DistanceMeasuring";
import { hoveredDeviceID } from "./SortUtility";

export const hasError = ref(null); // 오류 발생 여부
export const errorMessage = ref('Error'); // 오류 메시지
export function setError(message) {
  hasError.value = true;
  errorMessage.value = message;
}
export function clearError() {
  hasError.value = false;
  errorMessage.value = '';
  location.reload(); // 페이지 새로고침
}

export const loginedUserData = async () => {
  const session = localStorage.getItem("session");
  if (session) {
    const parsedSession = JSON.parse(session);
    if (parsedSession.userinfo) {
      return parsedSession.userinfo;
    } else {
      const loginId = parsedSession.loginid || "Guest";
      
      if (loginId && loginId !== "Guest") {
        const nowData = await GET_SERVER_REQUEST('user', `/${loginId}`);
        return nowData;
      } else {
        return "Guest";
      }
    }
  } else {
    return "Guest";
  }
};

export const SessionTime = 31536000 * 1000;

export const ConvertDateTimeString = (datetime, type = '') => {
  const options = { year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false };
  let converter;

  switch (type) {
      case '':
        converter = datetime.replaceAll(':', '').replaceAll('-', '').replaceAll('T', '');
        return converter;
          
      case 'YYYYMMDDHHMM':
        converter = datetime.toLocaleString(undefined, options).replaceAll(':', '').replaceAll('.', '').replaceAll(' ', '').substring(0, 12);
        return converter;
          
      case 'YYYY-MM-DDTHH:MM':
        converter = datetime.toLocaleString(undefined, options).replaceAll('.', '-').replaceAll(' ', '').slice(0,16);
        return converter.slice(0, 10) + 'T' + converter.slice(11);

      case 'YYYY-MM-DD HH:MM:SS':
        converter = datetime.toLocaleString(undefined, options).replaceAll('.', '-').replaceAll(' ', '').slice(0,19);
        return converter.slice(0, 10) + ' ' + converter.slice(11);
        
      case 'YYYYMMDD':
        converter = datetime.toLocaleString(undefined, options).replaceAll(':', '').replaceAll('.', '').replaceAll(' ', '').substring(0, 8);
        return converter;
      
      case 'YYYY-MM-DD':
        converter = datetime.toLocaleString(undefined, options).replaceAll('.', '-').replaceAll(' ', '').slice(0,16);
        return converter.slice(0, 10);

      case 'HH:MM':
        converter = datetime.toLocaleString(undefined, options).replaceAll('.', '-').replaceAll(' ', '').slice(0,16);
        return converter.slice(11);
  }
  return datetime;
};
// 위에꺼랑 좀 다르게 확실하게 고정함(위에껀 dd-mm-yyyy hh:mm:ss 이렇게 뒤집어서 나올 수 있음)
export const formatDate = (date) => {
  const pad = (n) => n.toString().padStart(2, '0');
  const yyyy = date.getFullYear();
  const mm = pad(date.getMonth() + 1);
  const dd = pad(date.getDate());
  const hh = pad(date.getHours());
  const mi = pad(date.getMinutes());
  const ss = pad(date.getSeconds());
  return `${yyyy}-${mm}-${dd} ${hh}:${mi}:${ss}`;
}

export const sleep = (ms) => {
  loadingStore.showLoading();
  let nowDate = Date.now();
  const wakeUpTime = nowDate + ms;
  while (nowDate < wakeUpTime) { nowDate = Date.now(); }
  loadingStore.hideLoading();
};

export const get_lastupdate_time = (timestamp) => {
  // const now = new Date() - (timestamp ? new Date(timestamp) : new Date("2021-03-08T09:00:00.000Z"));
  
  if (!timestamp) return MAX_TIME.value;
  
  // 1. Z가 붙은 UTC 시간(데이터)을 파싱
  const utcDate = new Date(timestamp); 
  
  // 2. 현재 시간 (시스템 시간)
  const now = new Date();

  // 3. 핵심 보정: 
  // 데이터가 사실은 UTC+2(남수단 시간)이므로, UTC(0)인 지금의 타임스탬프에서 
  // 2시간(7200초)을 빼주어야 '현재 시간(KST)'과 비교 가능한 절대 시간이 됩니다.
  const targetTime = utcDate.getTime() - (2 * 60 * 60 * 1000); 

  // 4. 차이 계산
  const diffMs = now.getTime() - targetTime;
  const calTime = Math.floor(diffMs / 1000);

  const isSoOld = calTime >= MAX_TIME.value // 연결시간이 오래된 단말
  return isSoOld ? MAX_TIME.value : calTime;
};

//#region WebSocket 사용한 알림 관련
export const notifier = ref(null);

// 이벤트 타입 매핑 함수
export const eventType = (type) => {
  const typeMap = {
    0: "info",
    1: "warning",
    2: "error",
  };
  return typeMap[type] || "unknown";
};
// 이벤트 중 특정 값의 키를 찾는 함수
export const getEvnetKeyByValue = (value) => {
  const typeMap = {
    0: "info",
    1: "warning",
    2: "error",
  };
  const index = Object.values(typeMap).indexOf(value);
  return index !== -1 ? Number(Object.keys(typeMap)[index]) : null; // 값이 없으면 null 반환
};
//#endregion

//#region 에러로그 전송
export const SendErrorLog = async (type, error) => {
  const totalData = {
    type: type,
    message: `[${error?.name ?? 'X'}] ${error?.message ?? error}`,
    description: error?.stack ?? error
  }
  const jsonData = JSON.stringify(totalData);
  await SERVER_REQUEST('log', 'POST', jsonData, false);
};
//#endregion

export const doNotShowErrorScreen = ref(false);

export const nowLoginUserID = computed(() => {
  try {
    const sessionData = localStorage.getItem("session") || "{}";  // 기본값을 빈 객체 JSON으로 설정
    return JSON.parse(sessionData).loginid || "Guest";  // 기본값을 "Guest"로 설정
  } catch (error) {
    console.error("세션 데이터 JSON 파싱 오류:", error);
    return "Guest";
  }
});

//#region 키 입력 관련
export const handleKeyboard = (e) => {
  const isShowMainVeiw = !(isDeviceModalSimpleOpen.value || isPathModalOpen.value || isPOIModalSimpleOpen.value || isAuthEditModalOpen.value || isMenuModalOpen.value);

  if (e.key === 'Escape') {
    e.preventDefault(); // 브라우저 기존 기능 차단
    if (showSmallModal.value) { showSmallModal.value = false; return; }
    if (isMeasuring.value) { stopMeasuring(state.map); return; }
    if (isDeviceModalSimpleOpen.value) { isDeviceModalSimpleOpen.value = false; return; }
    if (isPathModalOpen.value) { isPathModalOpen.value = false; return; }
    if (isAuthEditModalOpen.value) { isAuthEditModalOpen.value = false; return; }
    if (isPOIModalSimpleOpen.value) { isPOIModalSimpleOpen.value = false; return; }
    if (isPOIModalSimpleOpen2.value) { isPOIModalSimpleOpen2.value = false; return; }
    if (isMenuModalOpen.value) { isMenuModalOpen.value = false; return; }

    return;
  }
  if (e.key === ' ') { 
    e.preventDefault();
    if (!isShowMainVeiw) return;

    // 마커에 마우스 올리고 스페이스 = 해당 마커 중심으로 setView
    if (hoveredDeviceID.value.size > 0) {
      state.map.setView(Object.values(state.locations.filter(location => hoveredDeviceID.value.has(location.device_id))
                                .flat()
                                .map(({ latitude, longitude }) => [latitude, longitude])[0]));
      return;
    }
    // 리스트에 마우스 올리고 스페이스 = 해당 마커 중심으로 setView (단말기 마커)
    if (mouseHoveredDevice.value) {
      state.map.setView(Object.values(state.locations.filter(location => mouseHoveredDevice.value === location.device_id))
                              .map(({ latitude, longitude }) => [latitude, longitude])[0]); 
      return;
    }
    // 리스트에 마우스 올리고 스페이스 = 해당 마커 중심으로 setView (기지국 마커)
    if (mouseHoveredNB.value || mouseHoveredNBMarker.value) {
      state.map.setView(baseStationMarkers.value.find(nb => (nb.id === mouseHoveredNB.value) || (nb.id === mouseHoveredNBMarker.value)).marker.getLatLng()); 
      return;
    }
    if (mouseHoveredCPE.value || mouseHoveredCPEMarker.value) {
      state.map.setView(CPEMarkers.value.find(ue => (ue.id === mouseHoveredCPE.value) || (ue.id === mouseHoveredCPEMarker.value)).marker.getLatLng()); 
      return;
    }
    // 단말기가 없는 상태라면 최초 위치와 최초 줌으로 변경
    if (state.locations.length === 0) {
      state.map.setView(defaultLocation.value, defaultZoomLevel.value); return;
    }

    state.map.fitBounds(Object.values(state.locations)
                              .flat() // 모든 단말기의 위치 배열을 하나로 합침
                              .map(({ latitude, longitude }) => [latitude, longitude]));
    return;
  }
  if (e.key === 'F1') {
    e.preventDefault(); // 브라우저 기존 기능 차단
    if (!isMenuModalOpen.value) {
      isMenuModalOpen.value = true;
    } else isMenuModalOpen.value = false;

    return;
  }
  
  if (e.altKey && e.key === "1") {
    
    return;
  }
};
//#endregion

//#region 모바일 UI 대응 관련
const isMobile = ref(window.innerWidth <= 767);
export const setIsMoblie = () => { isMobile.value = window.innerWidth <= 767 };
export const getIsMobile = () => { return isMobile.value };
//#endregion

//#region 시간 및 날씨 표시 관련
export const currentTime = ref("");
const currentFormatIndex = ref(0);
const timeFormats = [
  'yyyy.MM.dd HH:mm:ss',  // 2025.02.07 14:00:00
  'h:mm:ss a',            // 오후 2:00:00 (12시간제)
  'HH:mm:ss',             // 14:00:00 (24시간제)
  'yyyy.MM.dd',           // 2025.02.07 (날짜만)
];
export const nowWeather = ref();

// ✅ 1. 현재 시간 업데이트
export const updateTime = async () => {
  const now = new Date();
  currentTime.value = formatTime(now, timeFormats[currentFormatIndex.value]);

  // 정시마다 커스텀마커 자동확인 및 날씨 업데이트
  if (now.getSeconds() === 0 && now.getMinutes() === 0 ) {
    fetchCustomMarker();
    // nowWeather.value = await GET_SERVER_REQUEST('weather');
  }
};
// 시간 포맷 변경 함수
export const timeFormatConversion = () => {
  currentFormatIndex.value = (currentFormatIndex.value + 1) % timeFormats.length;
  updateTime();
};
// 날짜 포맷 변환 함수
const formatTime = (date, format) => {
  return new Intl.DateTimeFormat('ko-KR', getFormatOptions(format)).format(date);
};
// 포맷 옵션 설정 함수
const getFormatOptions = (format) => {
  const options = {
    'h:mm:ss a': { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true }, // 12시간제
    'HH:mm:ss': { hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }, // 24시간제
    'yyyy.MM.dd': { year: 'numeric', month: '2-digit', day: '2-digit' }, // 날짜만
    'yyyy.MM.dd HH:mm:ss': { 
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false 
    } // 날짜 + 24시간제 시간
  };
  return options[format] || options['HH:mm:ss'];
};

export const weatherImage = computed(() => {
  if (!nowWeather.value) return new URL('@/assets/weathers/02d.png', import.meta.url).href;
  const iconKey = nowWeather.value.weather_value.weather[0]?.icon || '02d';
  const weatherIcon = require(`@/assets/weathers/${iconKey}.png`);
  return weatherIcon;
})
//#endregion

//#region 심시스 복호화
import CryptoJS from 'crypto-js';
export const decryptAES = (encryptedData, encryptionKey = "smartcamp1234567") => {
  try {
    if (!encryptedData) return null;
    // 1. Base64 디코딩: Java 코드에서 Base64로 인코딩했으므로, JS에서도 Base64 디코딩이 필요합니다.
    //    CryptoJS는 Base64 인코딩된 문자열을 직접 처리할 수 있습니다.
    const decrypted = CryptoJS.AES.decrypt(
      encryptedData,
      CryptoJS.enc.Utf8.parse(encryptionKey), // Java의 getBytes()와 동일하게 UTF-8로 키를 파싱
      {
        mode: CryptoJS.mode.ECB, // Java 코드에서 별도 명시 없으면 기본 ECB 모드일 가능성 높음
        padding: CryptoJS.pad.Pkcs7 // Java Cipher 기본 패딩인 PKCS7 패딩
      }
    );

    // 2. 복호화된 데이터를 UTF-8 문자열로 변환
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (error) {
    console.error("복호화 중 오류 발생:", error);
    return null; // 또는 에러 처리 방식에 따라 다르게 반환
  }
}
//#endregion

//#region NB 마지막 업데이트 시간
export const nbLastUpdateTime = (nb) => {
  const lanTime = nb.latest_lan_info?.timestamp;
  const gpsTime = nb.latest_gps_info?.timestamp;
  const stateTime = nb.latest_service_state_info?.timestamp;
  const epcTime = nb.latest_service_state_info?.epc_timestamp;

  const timestamps = [lanTime, gpsTime, stateTime, epcTime]
    .filter(t => t)
    .map(t => {
      // 핵심: 데이터가 이미 남수단 시간(UTC+2)이라면, 
      // 파싱할 때 'Z'를 붙여서 '이건 UTC+2인 시간이야'라고 정확히 인식시켜야 함.
      // 2026-07-02 02:38:20 -> 2026-07-02T02:38:20+02:00
      return new Date(t.replace(' ', 'T') + '+02:00').getTime();
    });

  // const timestamps = [lanTime, gpsTime, stateTime, epcTime].filter(t => t).map(t => new Date(t.replace(' ', 'T') + 'Z'));
  const validTimestamps = timestamps.filter(date => !isNaN(date));

  if (validTimestamps.length === 0) return 9999;
  const latestTime = new Date(Math.max(...validTimestamps));
  // const currentTime = new Date();
  const currentTime = new Date((new Date().getTime()));
  const timeDifferenceMs = currentTime.getTime() - latestTime.getTime();
  const timeDifferenceSeconds = Math.floor(timeDifferenceMs / 1000);
  if (timeDifferenceSeconds > 9999) return 9999
  // else if (timeDifferenceSeconds < 0) return 0; // 미래 시간으로 찍힐 경우 0초로 표시
  else return timeDifferenceSeconds;
}
//#endregion

//#region UE 마지막 업데이트 시간
export const cpeLastUpdateTime = (ue) => {
  const time = ue.timestamp;

  const timestamps = [time]
    .filter(t => t)
    .map(t => {
      // 핵심: 데이터가 이미 남수단 시간(UTC+2)이라면, 
      // 파싱할 때 'Z'를 붙여서 '이건 UTC+2인 시간이야'라고 정확히 인식시켜야 함.
      // 2026-07-02 02:38:20 -> 2026-07-02T02:38:20+02:00
      return new Date(t.replace(' ', 'T') + '+02:00').getTime();
    });
  // const timestamps = [time].filter(t => t).map(t => new Date(t.replace(' ', 'T') + 'Z'));
  // const validTimestamps = timestamps.filter(date => !isNaN(date.getTime()));
  const validTimestamps = timestamps.filter(date => !isNaN(date));

  if (validTimestamps.length === 0) return 9999;
  const latestTime = new Date(Math.max(...validTimestamps));
  const currentTime = new Date();
  const timeDifferenceMs = currentTime.getTime() - latestTime.getTime();
  const timeDifferenceSeconds = Math.floor(timeDifferenceMs / 1000);
  if (timeDifferenceSeconds > 9999) return 9999
  else return timeDifferenceSeconds;
}
//#endregion